export const httpConstants = {
  GET_REQUEST: 'HTTP_GET_REQUEST',
  POST_REQUEST: 'HTTP_POST_REQUEST',
  POST_REQUEST_CALLBACK_DATA: 'HTTP_POST_REQUEST_CALLBACK_DATA',
  DELETE_REQUEST: 'HTTP_DELETE_REQUEST',
}
